export default "__VITE_ASSET__BWe3lCfv__"